import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { adminVerify } from '../../services/adminApi';

interface ProtectedRouteProps {
  children: React.ReactElement;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const [checking, setChecking] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    adminVerify()
      .then((isAuth) => {
        setAuthenticated(isAuth);
      })
      .catch(() => {
        setAuthenticated(false);
      })
      .finally(() => {
        setChecking(false);
      });
  }, []);

  if (checking) {
    return (
      <div className="admin-page">
        <div className="loading">Checking authentication...</div>
      </div>
    );
  }

  if (!authenticated) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
}
